/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from 'lodash/get';
import { getPath } from '../../../utils';

function checkIfStoryPublic (story) {
  const access = get(story, ['access']);
  return access === 'public' || access === null;
}

const navigateToAuthDomain = async (bridgeKeeperClientId = '', sketchesHost, whiteListedUrlParams = []) => {
  if (window?.location) {
    const { getOauthAuthorizeUrl } = await import('@quintype/bridgekeeper-js');
    const redirectUrl = getPath({
      sketchesHost,
      relativePath: '/api/auth/v1/oauth/token',
      absolutePath: `${window.location.origin}/api/auth/v1/oauth/token`
    });
    const oauthAuthorizeUrl = await getOauthAuthorizeUrl(
      bridgeKeeperClientId,
      redirectUrl,
      encodeURIComponent(window.location.href)
    );
    window.location.replace(oauthAuthorizeUrl);
  }
};

const checkIfSingleSignOn = (sso = {}) => {
  const { enableSingleSignOn = '', bridgeKeeperClientId = '' } = sso;
  return bridgeKeeperClientId && enableSingleSignOn;
};

const getLoginLink = (member, sso = {}, sketchesHost, whiteListedUrlParams = []) => {
  const navigateToSignInPage = () => {
    window.location.href = getPath({
      sketchesHost,
      relativePath: '/sign-in',
      injectCustomParams: true,
      whiteListedUrlParams
    });
  };

  if (!member?.['verification-status'] && checkIfSingleSignOn(sso)) {
    return navigateToAuthDomain(sso?.bridgeKeeperClientId, sketchesHost, whiteListedUrlParams);
  } else {
    global?.localStorage?.setItem('loginRedirectUrl', window?.location?.href);
    return navigateToSignInPage();
  }
};

export { checkIfStoryPublic, navigateToAuthDomain, checkIfSingleSignOn, getLoginLink };
